import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { IonPopover, IonSearchbar } from '@ionic/angular';
import { SearchbarCustomEvent } from '@ionic/core';
import { asyncScheduler, Subscription } from 'rxjs';

import { SharedAnalyticsService } from '../../../analytics/shared-analytics/shared-analytics.service';
import { EAnalyticsHeaderLabels } from '../../../enums/analytics.enum';
import { SECTIONS } from '../../../models/Constants';
import { IProductos } from './../../../../private/shared/models/productos';
import { NativeStorageNamesV2 } from './../../../models/Constants';
import { StorageData } from './../../../services/utilities/storage-data.class';

@Component({
  selector: 'getm-search-component',
  templateUrl: './search-component.component.html',
  styleUrls: ['./search-component.component.scss']
})
export class SearchComponentComponent implements OnInit, OnDestroy {

  @ViewChild('getmSearchbar', { read: ElementRef }) searchbarRef!: ElementRef;
  @ViewChild('popoverGETMSearchProduct', { static: false }) popoverGETM!: IonPopover;
  @ViewChild('popoverGETMSearchRecent', { static: false }) popoverGETMRecent!: IonPopover;

  @Input() products: Array<IProductos> = [];

  @Output() searchChange = new EventEmitter<string>();
  @Output() productSelected = new EventEmitter<IProductos>();

  public showSkuList = false;
  public showRecentList = false;
  public searchProduct: string = '';
  public recentSearchs: Array<IProductos> = [];

  private isBlurring = false;
  private windowHeight = window.innerHeight;
  private mainSubscription: Subscription = new Subscription();

  constructor(private sharedAnalyticsS: SharedAnalyticsService) { }

  async ngOnInit() {
    this.recentSearchs = (await StorageData.getDataStorage(NativeStorageNamesV2.RecentSearches) as Array<IProductos>) || [];
  }

  ngOnDestroy(): void {
    this.mainSubscription.unsubscribe();
    this.onClearSearch();
    if (this.popoverGETM) this.popoverGETM.dismiss();
    if (this.popoverGETMRecent) this.popoverGETMRecent.dismiss();
  }

  public ionFocusSearch = (event: CustomEvent, searchbar: IonSearchbar) => {
    this.sharedAnalyticsS.trackInteractionHeader({
      section: SECTIONS.TIENDA,
      label: EAnalyticsHeaderLabels.BUSCADOR
    });
    if (this.isBlurring) {
      this.showSkuList = false;
      this.showRecentList = false;
      searchbar.getInputElement().then((element) => element.blur());
      return;
    }
    if (this.recentSearchs.length > 0 && this.searchProduct.length < 1) {
      this.popoverGETMRecent.event = event;
      this.showRecentList = true;
      this.applyTopBackdrop();
    }
  }

  public ionBlurSearch = (searchbar: IonSearchbar) => {
    this.isBlurring = true;
    this.onBlur(searchbar);
  }

  public onSearchChange = (event: SearchbarCustomEvent) => {
    if ((event?.detail?.value || '').length > 0) {
      this.popoverGETM.event = event;
      this.showSkuList = true;
      this.showRecentList = false;
      this.applyTopBackdrop();
    }
    if ((event?.detail?.value || '').length === 0) {
      this.onClearSearch();
      if (this.recentSearchs.length > 0) {
        this.popoverGETMRecent.event = event;
        this.showRecentList = true;
        this.applyTopBackdrop();
      }
    }
  }

  public onClearSearch = (event: CustomEvent | null = null) => {
    this.searchProduct = '';
    this.showSkuList = false;
    if (event && this.recentSearchs.length > 0) {
      this.popoverGETMRecent.event = event;
      this.showRecentList = true;
      this.searchbarRef?.nativeElement.setFocus();
      this.applyTopBackdrop();
    }
  }

  public onProductSelected = async (product: IProductos, searchbar: IonSearchbar) => {
    this.productSelected.emit(product);
    this.onClearSearch();
    this.showRecentList = false;
    this.onBlur(searchbar);

    this.recentSearchs = this.recentSearchs.filter(item => item.clave_producto !== product.clave_producto);
    this.recentSearchs.unshift(product);
    this.recentSearchs = this.recentSearchs.slice(0, 5);
    await StorageData.setDataStorage(NativeStorageNamesV2.RecentSearches, this.recentSearchs);
  }

  public goAllMatches = (searchbar: IonSearchbar) => {
    this.searchChange.emit(this.searchProduct);
    this.showSkuList = false;
    this.onBlur(searchbar);
  }

  public onBlur = (searchbar: IonSearchbar) => {
    this.mainSubscription.add(asyncScheduler.schedule(() => {
      this.showSkuList = false;
      this.showRecentList = false;
      searchbar.getInputElement().then((element) => element.blur());
    }, 300));

    this.mainSubscription.add(asyncScheduler.schedule(() => this.isBlurring = false, 500));
  }

  private applyTopBackdrop = () => {
    let searchDistance = 0;
    const maxHeight = this.windowHeight >= 750 ? 330 : 230;
    if (this.searchbarRef) {
      const element = this.searchbarRef.nativeElement;
      const rect = element.getBoundingClientRect();
      searchDistance = rect.top + rect.height;
    }
    if (this.popoverGETM && this.popoverGETM['el']) {
      const popoverNativeElement = this.popoverGETM['el'];
      popoverNativeElement.style.setProperty('--searchbar-top-offset', `${searchDistance}px`);
      popoverNativeElement.style.setProperty('--searchbar-max-height', `${maxHeight}px`);
    }
    if (this.popoverGETMRecent && this.popoverGETMRecent['el']) {
      const popoverNativeElement = this.popoverGETMRecent['el'];
      popoverNativeElement.style.setProperty('--searchbar-top-offset', `${searchDistance}px`);
      popoverNativeElement.style.setProperty('--searchbar-max-height', `${maxHeight}px`);
    }
  }

}
